/** v-tableSelection
 * 功能描述：el-table 单击勾选
 * 使用范围：el-table
*/
export default {
    name: 'tableSelection',
    bind(el, binding, vnode) {
        // console.log('bind', el, binding, vnode);

        if(!vnode.componentOptions || vnode.componentOptions.tag !== 'el-table') {
            throw new Error('el-table is not bound！');
        }

        const table = vnode.componentInstance;
        table.$on('row-click', (row) => {
            const selection = table.store.states.selection;
            if(selection.indexOf(row) != -1) {
                table.toggleRowSelection(row, false);
            }else {
                table.toggleRowSelection(row, true);
            }
        });
    },
    unbind(el) {
        // console.log('unbind', el);
    }
};
